// Script for filtering on journal page and loading more articles when clicking on load more button
var timer;
var page = 0;
var doneTypingInterval = 1500;
var $checkboxNewsTypeList;
var $checkboxCategoryList;
var queryParameterDivider = '|';
var defaultfilter;
var masonryOptions = {
	itemSelector: ".c-masonry__item",
	percentPosition: true,
	columnWidth: ".c-masonry__sizer",
	gutter: 24,
}

function getFilter(list, returnEmptyIfNull) {
    var jsonObj = [];

    $.each(list, function (index, value) {

        if ($(value).is(":visible")) {
            var item = {};
            item["key"] = $(value).data('id');
            item["value"] = $(value).prop('checked');
            jsonObj.push(item);
        }
    });

    if (jsonObj.length === 0) {
        if (returnEmptyIfNull)
            return { "": false };

        jsonObj = defaultfilter;
    }

    return jsonObj;
};

function executeFilter(appendContent) {

    var $hubComponent = $('.js-journal-component'),
        $hubButton = $(".js-journal-button"),
        scController = $hubButton.data('sccontroller'),
        scAction = $hubButton.data('scaction'),
        newsJournalSourceId = $hubButton.data('journalhub-id'),
        pagesize = $hubButton.data('pagesize');
        defaultfilter = $hubButton.data('filter');

    if (appendContent) { page++; } else { page = 0; }

    var journalNewsTypeFilterSelection = getFilter($checkboxNewsTypeList, true);
    var journalCategoryFilterSelection = getFilter($checkboxCategoryList, true);

    $.ajax({
        url: window.location.href,
        type: "POST",
        context: this,
        data: {
            scController: scController,
            scAction: scAction,
            journalNewsTypeFilter: journalNewsTypeFilterSelection,
            newsJournalSourceId: newsJournalSourceId,
            pageSize: pagesize,
            page: page,
            journalCategoryFilter: journalCategoryFilterSelection
        },

        success: function (data) {
            var $dataChildren = $(data.content).find('.js-journal-component').children();
            var $data = $(data.content).find('.js-journal-component');

            if (appendContent) {
                $hubComponent.append($dataChildren);
                if ($hubComponent.hasClass('.js-layout-masonry')) {
                    $hubComponent.masonry(masonryOptions);
                    $hubComponent.masonry("appended", $dataChildren);
                }
            } else {
                $hubComponent.hide().replaceWith(function () {
                    return $data.hide().fadeIn();
                });
                $('.js-layout-masonry').masonry(masonryOptions);
                $('.js-layout-masonry').masonry('appended', $dataChildren);
            }

            // set button visability
            if (!data.showMore) {
                $hubButton.hide();
            } else {
                $hubButton.show();
            }

        },

        error: function (data) {
            console.log("error", data);
        },

        complete: function () {
            //
        }
    });
}

function init() {

    // Init filter checkboxes
    $checkboxCategoryList = initForType('.js-journal-category-filter');
    $checkboxNewsTypeList = initForType('.js-journal-newstype-filter');

    // init more-button
    $('.js-journal-button').on('click', function (e) {
        e.preventDefault();
        executeFilter(true);
    });
}

function initForType(className) {
    // Init filter checkboxes
    var list = $(className).find(':checkbox');
    list.on('click', function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
            executeFilter(false);
            onFilterChange();
        }, doneTypingInterval);
    });

    return list;
}

function onFilterChange() {
    var journalNewsTypeFilter = getFilter($checkboxNewsTypeList, false);
    var journalCategoryFilter = getFilter($checkboxCategoryList, false);

    // get all active filters, map their keys to an array, stringify the array and separate them using queryParameterDivider
    var transformFilterToString = (obj) => { return obj.filter(item => item.value === true).map(item => item.key).join(queryParameterDivider); }

    var activeNewsTypes = transformFilterToString(journalNewsTypeFilter);
    var activeCategories = transformFilterToString(journalCategoryFilter);

    setQueryParameters({ "types": activeNewsTypes, "cats": activeCategories });
}

function setQueryParameters(parameters) {
    var queryString = '';
    if (parameters.types) {
        queryString += 'types=' + encodeURIComponent(parameters.types);
    }
    if (parameters.cats) {
        var param = '';
        if (queryString.length > 0) {
            param += '&';
        }

        queryString += (param + 'cats=' + encodeURIComponent(parameters.cats));
    }

    // retrieve url without query parameters; split on '?' character
    var url = window.location.href.split('?')[0];
    // concatenate the url with the querystring and push it to the browser
    history.pushState(null, '', url + '?' + queryString);

    // set pop state event for when the user browses through the history
    window.onpopstate = function() {
        window.location.reload();
    };
}

$(init);